import { render } from "./MarkersConfig.vue?vue&type=template&id=16066efe&scoped=true"
import script from "./MarkersConfig.vue?vue&type=script&lang=js"
export * from "./MarkersConfig.vue?vue&type=script&lang=js"

import "./MarkersConfig.vue?vue&type=style&index=0&id=16066efe&scoped=true&lang=css"

import exportComponent from "/dev/shm/repo/airmap-2s5z7ythbr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16066efe"]])

export default __exports__